import { Grid } from "@mui/material";
import { Typography } from "antd";
import { useContext, useState } from "react";
import { useTranslation } from "react-i18next";
import DialogBox from "../../components/DialogBoxComponent/DialogBox";
import { ThemeContext } from "../../theme/ThemeContext";

function PrinterDialogBox(props) {
  const { t } = useTranslation();
  const [open, setOpen] = useState(true);
  const { darkMode } = useContext(ThemeContext);

  const handleClose = () => {
    props.onClose();
  };
  const handleSubmit = () => {
    props.onSubmit();
  };

  return (
    <>
      <DialogBox
        Header={t("Dymo Printer")}
        acceptText={t("Print")}
        cancelText={t("COMMON008")}
        onClose={handleClose}
        cancel={handleClose}
        onSubmit={handleSubmit}
        open={props.open}
      >
        <Grid
          container
          justifyContent="center"
          direction="column"
          alignItems="center"
          style={{
            backgroundColor: darkMode ? "#0E2A41" : "",
          }}
        >
          <Grid
            item
            style={{
              opacity: 1,
              textAlign: "center",
              display: "flex",
              flexDirection: "row",
              fontSize: "17px",
              marginTop: "15px",
              color: darkMode ? "#fff" : "#242424",
            }}
          >
            <Typography
              style={{
                fontSize: "15px",
                whiteSpace: "pre-line",
                color: darkMode ? "#fff" : "#242424",
              }}
            >
              {t("Do you want to proceed with printing the visitor label?")}
            </Typography>
          </Grid>
        </Grid>
      </DialogBox>
    </>
  );
}

export default PrinterDialogBox;
